import { MenuItem, MenuItemType } from '../Menu/components/MenuItem';
import { Menu, MenuProps } from '../Menu/Menu';
import { Heading } from '../Typography/Heading';

export type MenuGroup = {
  label: string;
  items: MenuItemType[];
};

type Props = {
  groups: MenuGroup[];
} & MenuProps;

export const GroupedMenu = ({
  groups,
  disableAutoClose,
  ...restMenuProps
}: Props) => {
  return (
    <Menu
      renderMenuItems={() => (
        <>
          {groups.map((group) => (
            <div key={group.label} className="py-1">
              <Heading
                size="xs"
                color="text-gray-700"
                className="flex items-center gap-3 self-stretch px-4 py-2"
              >
                {group.label}
              </Heading>
              {group.items.map((item) => (
                <MenuItem
                  key={item.id}
                  item={item}
                  handleItemClick={() => {
                    if ('onClick' in item) {
                      item.onClick();
                    }
                  }}
                  disableAutoClose={disableAutoClose}
                />
              ))}
            </div>
          ))}
        </>
      )}
      {...restMenuProps}
    />
  );
};
